import Loading from '@/components/Loading';
import useFetchAdminImportRequest from '../../api/useFetchAdminImportRequest';
import DonePage from './DonePage';
import FailedPage from './FailedPage';
import PendingPage from './PendingPage';

type DetailPageProps = {
  importRequestId: number;
};

export default function DetailPage({ importRequestId }: DetailPageProps) {
  const { data, isLoading, isError } = useFetchAdminImportRequest(importRequestId);

  if (isLoading) {
    return (
      <div className="flex min-h-[360px] items-center justify-center">
        <Loading />
      </div>
    );
  }

  if (isError || !data) {
    return <div />;
  }

  if (data.status === 'pending') {
    return (
      <PendingPage
        importRequestId={importRequestId}
        status={data.status}
        adminUserName={data.admin_user_name}
        jobSourceId={data.job_source_id}
        jobSourceLoginId={data.job_source_login_id}
        jobSourceLoginUrl={data.job_source_login_url}
        jobSourceLoginPass={data.job_source_login_pass}
      />
    );
  }

  if (data.status === 'done') {
    return <DonePage />;
  }

  if (data.status === 'failed') {
    return <FailedPage status={data.status} adminUserName={data.admin_user_name} />;
  }

  return <div />;
}
